interface Props {
  color: string;
  selected: boolean;
  disabled: boolean;
  toggleOption: () => void;
  isProductBox?: boolean;
  outOfStock?: boolean;
}
const SvgColorOption: React.FC<Props> = ({
  color,
  selected,
  disabled,
  toggleOption,
  isProductBox,
  outOfStock,
}) => {
  const dim = isProductBox ? 16 : 32;
  return (
    <svg
      style={{ cursor: disabled || outOfStock ? "not-allowed" : "pointer" }}
      onClick={disabled ? undefined : toggleOption}
      width={dim}
      height={dim}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16"
        cy="16"
        r={`${disabled || outOfStock  ? "15.5" : "15"}`}
        fill={color}
        className={`${selected ? "stroke-primary" : "stroke-gray4"}`}
        fillOpacity={`${disabled || outOfStock  ? "0.1" : "01"}`}
        strokeWidth={`${disabled || outOfStock  ? "1" : "2"}`}
      />
      {disabled || outOfStock  && (
        <line
          x1="5.35355"
          y1="4.64645"
          x2="27.3536"
          y2="26.6464"
          className="stroke-gray4"
        />
      )}
    </svg>
  );
};

export default SvgColorOption;
